import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createProdutoAgricolaCadastro, updateProdutoAgricolaCadastro } from '../service';
import {
  CREATE_PRODUTO_AGRICOLA_CADASTRO,
  CREATE_PRODUTO_AGRICOLA_CADASTRO_PENDING,
  CREATE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
  CREATE_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
  findAllSafrasByPropriedade,
  CONFIG_SESSION,
} from '@handler';
import { storage } from '@commons/storage';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateProdutoAgricolaCadastro(action) {
  yield put({ type: CREATE_PRODUTO_AGRICOLA_CADASTRO_PENDING });

  try {
    delete action.data.cultura.categoriaDesc;

    if (action.data.dadosFiscaisItemNfe.informarDadosNfe === false) {
      action.data = {
        ...action.data,
        dadosFiscaisItemNfe: {
          informarDadosNfe: false,
          nomeItemNF: '',
          codigoProduto: action.data.dadosFiscaisItemNfe.codigoProduto,
          ncm: '',
          ncmEx: '',
          cest: '',
          gtinEan: '',
          cbenef: '',
          unidadeTributavel: null,
          gtinEanTributavel: '',
          cfopEstadual: null,
          cfopInterestadual: null,
          cfopExportacao: null,
          tabelaTributaria: null,
        }
      }
    }

    if (action.data.id === undefined || action.data.id === null) {
      yield call(createProdutoAgricolaCadastro, action.data);
      trackingEventCX('action', MODULE_ACTIONS_ENUM.PRODUTOS_AGRICOLA_CRIAR);
    } else {
      yield call(updateProdutoAgricolaCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.PRODUTOS_AGRICOLA_EDITAR);

      // ATUALIZA SAFRA NA SESSAO
      const safras = yield call(findAllSafrasByPropriedade, JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id);

      const configSessionAtual = JSON.parse(storage.get(CONFIG_SESSION));
      let safraSelecionada = null;

      if (safras != null && safras.content != null) {
        if (safras.content.length === 1) {
          safraSelecionada = safras.content[0];
        } else {
          if (configSessionAtual.safraAtiva !== null) {
            for (var i = 0; i < safras.content.length; i++) {
              if (safras.content[i].id == configSessionAtual.safraAtiva.id) {
                safraSelecionada = safras.content[i];
              }
            }
          }
        }

        if (safraSelecionada != null) {
          const configSession = {
            ...configSessionAtual,
            safras: safras.content,
            safraAtiva: safraSelecionada
          }

          yield storage.set(CONFIG_SESSION, JSON.stringify(configSession));
        }
      }
    }

    yield put({ type: CREATE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS, registro: action.data });

    if (!action.isCadastroRapido) {
      history.push('/produtoAgricolaCadastro');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_PRODUTO_AGRICOLA_CADASTRO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreateProdutoAgricolaCadastro() {
  yield takeLatest(CREATE_PRODUTO_AGRICOLA_CADASTRO, sagaCreateProdutoAgricolaCadastro);
}
